import { Box, Grid } from "@chakra-ui/react";

const WithAuth = (WrappedComponent: any) => {
  return (props: any) => {
    const user = JSON.parse(localStorage.getItem("barte-user-info"));
    const accessToken = localStorage.getItem("barte-auth-token");
    const blockedUrls = ["/saldo", "/transfers", "/invoices", "/feature-toggles", "/contestation"]
    if (!accessToken) {
      window.location.replace("/login");
      return <></>
    }
    
    if (!user || (!user?.email?.includes("@barte") && blockedUrls?.includes(window.location.pathname))) return (
      <Grid
        height="100%"
        width="100%"
        gridTemplateColumns="auto 1fr"
        gridTemplateRows="52px 1fr"
        gridTemplateAreas={`"S N" "S B" "S B"`}
        bgColor="gray.10"
      >
        <Box p="20px 20px 20px 80px" gridArea={"B"} h="100%" bgColor="gray.10">
          <span>Você não tem permissão para visualizar essa página!</span>
        </Box>
      </Grid>
    )
    return <WrappedComponent {...props} />
  }
}

export default WithAuth;